import { ReactNode } from 'react';

export type DataGridProps<T> = {
  columnsConfig: DataGridColumnConfig<T>[];
  data: T[];
  onClick?: (data: T) => void;
  hideCsvButton?: boolean;
  loading?: boolean;
};

export type DataGridData = Record<string, string>;

export type DataGridColumnConfig<T> = {
  name: string;
  labelId: string;
  formatCell?: (data: T) => ReactNode | string;
};

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type SortConfig<T> = {
  field: keyof T | null;
  direction: SortDirection;
};
